'use client'

import { useAiChatStatusContext } from '../context/ai-chat-state-context'

export const useAiChatStatus = () => useAiChatStatusContext()
